import App from '../App';
import { KompanSettingsManagerState } from './KompanSettingsManager';

import { StateManager } from '@egr/xbox/base-app/managers/Manager';

import { BackgroundSound } from '@egr/room/modules/utils/BackgroundSound';
import { RoomElement } from '@egr/room/modules/mdl/RoomElement';
import { SceneElement } from '@egr/wcf/modules/core/mdl';

interface MusicManagerState {
    hasGeneral: boolean;
    hasSphere: boolean;
    mute: boolean;
}

function isSphere(value: SceneElement) {
    return value instanceof RoomElement && value.type === 'Sphere';
}

export class MusicManager extends StateManager<MusicManagerState> {
    private backgroundSound: BackgroundSound | undefined;

    constructor(protected app: App) {
        super();
        this.initialize = this.initialize.bind(this);
        this.setMute = this.setMute.bind(this);
    }

    public initialize(soundData: KompanSettingsManagerState['soundData']) {
        const hasSphere = this.app.coreApp.model.elements.find(isSphere) != null;

        const callback = () => {
            if (this.backgroundSound == null) {
                return;
            }

            let hasGeneral: boolean = false;

            if (soundData?.effect != null) {
                this.backgroundSound.setAudioData_Effect(soundData.effect);
                hasGeneral = true;
            }
            if (soundData?.music) {
                this.backgroundSound.setAudioData_Music(soundData.music);
                hasGeneral = true;
            }

            this.app.roomManager.muteAudioSpheres(true);

            this.updateState({ hasGeneral, hasSphere });

            BackgroundSound.eventSoundListLoaded.removeListener(callback);
        };

        if (hasSphere || soundData != null) {
            BackgroundSound.eventSoundListLoaded.addListener(callback);
            this.backgroundSound = new BackgroundSound(this.app.roomManager);
        }
    }

    public setMute(mute: boolean) {
        if (this.backgroundSound == null) {
            return;
        }
        if (this.state.hasSphere) {
            this.app.roomManager.muteAudioSpheres(mute);
        }

        if (this.state.hasGeneral) {
            this.backgroundSound.autoPlay_effect = !mute;
            this.backgroundSound.autoPlay_music = !mute;
        }

        this.updateState({ mute });
    }

    protected override getInitialState(): Readonly<MusicManagerState> {
        return {
            hasGeneral: false,
            hasSphere: false,
            mute: true,
        };
    }
}